import { useEffect, useState } from "react"
import { useDispatch } from "react-redux";
import { UserSettings } from "./userSettings";
import { ProfileSettings } from "./profileSettings";
import { AvailabilitySettings } from "./availabilitySettings";
import { Toaster } from "react-hot-toast";
import { getTutorMe } from "../../store/profile/profileActions";
import { setProfile } from "../../store/profile/profileSlice";

const TutorSettings = () => {
    const [currentTab, setCurrentTab] = useState(0);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getTutorMe())
            .unwrap()
            .then((profile) => {
                dispatch(setProfile(profile));
            })
            .catch(() => {});
    }, [dispatch]);

    const handleTabChange = (tab) => {
        setCurrentTab(tab);
        document.getElementById('page-content')?.scrollTo({ top: 0, behavior: 'smooth' });
    };
        
    return (
        <div>
            <Toaster containerStyle={{zIndex: 9999999999 }} />
            <div className="">
                <ul className="flex bg-white rounded-xl p-3 px-5 justify-between mb-5 w-full lg:w-3/4 xl:w-3/4 mx-auto">
                    <li className={currentTab === 0 ? "cursor-pointer text-nt-blue text-center w-full font-semibold": "cursor-pointer text-nt-grey text-center w-full"} onClick={() => handleTabChange(0)}>
                        Account
                    </li>
                    <li className={currentTab === 1 ? "cursor-pointer text-nt-blue text-center w-full font-semibold": "cursor-pointer text-nt-grey text-center w-full"} onClick={() => handleTabChange(1)}>
                        Profile
                    </li>
                    <li className={currentTab === 2 ? "cursor-pointer text-nt-blue text-center w-full font-semibold": "cursor-pointer text-nt-grey text-center w-full"} onClick={() => handleTabChange(2)}>
                        Availability
                    </li>
                </ul>
            </div>
            {currentTab === 0 ? <UserSettings /> :
                currentTab === 1 ? <ProfileSettings /> : 
                currentTab === 2 ? <AvailabilitySettings />  : ""
            }
        </div>
    )
}
export { TutorSettings }